import { gql } from '@apollo/client';

export const FORWARDER_EXECUTE = gql`
  mutation Erc2771ForwarderExecute($data: ERC2771ForwarderExecuteInput!) {
    erc2771ForwarderExecute(data: $data) {
      enqueued
    }
  }
`;
